import { TbInfoCircle } from "react-icons/tb";

// HL-12999 (Figma 9699:15825): shown under the dose dropdown, in place of the "prescriber will review" line,
// while the selected dose needs proof of previous use. No close button.
const DoseNotice = ({ text, switchLabel, onSwitch }: { text: string; switchLabel: string; onSwitch: () => void }) => (
  <div id="wl3_treatment_dose_notice" className="flex gap-[8px] rounded-[12px] bg-[#fef6eb] p-[12px]">
    <TbInfoCircle size={20} className="shrink-0 text-[#e88103]" />
    <div className="flex min-w-0 flex-col gap-[12px]">
      <p className="font-roboto text-[14px] leading-[20px] text-[#08080a]">{text}</p>
      <button
        id="wl3_treatment_dose_notice_switch"
        type="button"
        onClick={onSwitch}
        className="w-fit cursor-pointer border-0 bg-transparent p-0 text-left font-poppins text-[14px] font-medium text-[#824f00] underline"
      >
        {switchLabel}
      </button>
    </div>
  </div>
);

export default DoseNotice;
